<template>
  <b-card no-body>
    <div class="card-padding d-flex justify-content-between align-items-center">
      <span class="header__label">Service Management</span>
      <atom-button
        v-if="hasUpdatePermission"
        buttonId="create-new-service"
        buttonStyle="border"
        @click="navigateTo('/global-settings/data-management/service/create')"
      >
        <template>
          <span class="d-none d-md-flex"> Create New Service </span>
          <span class="d-flex d-md-none"> New </span>
        </template>
      </atom-button>
    </div>
    <div class="row card-padding-x card-padding-bottom">
      <div class="col-12 col-md-5">
        <atom-input
          v-model="filterList.serviceName"
          title="Name"
          placeholder="Name"
        ></atom-input>
      </div>
      <div class="col-12 col-md-5 mt-1 mt-md-0">
        <atom-multi-select
          v-model="filterList.statuses"
          title="Status"
          placeholder="All Status"
          :option="['Active', 'Deprecated']"
          :isAppendToBody="false"
          :isEnableProper="false"
        ></atom-multi-select>
      </div>
      <div
        class="col-12 col-md-2 mt-1 mt-md-0 d-flex align-items-end justify-content-end justify-content-md-start"
      >
        <div class="d-flex align-items-center">
          <atom-button
            buttonId="button-search"
            iconLeft="SearchIcon"
            class="search__button ml-2"
            @click="clickButtonSearch"
          ></atom-button>
          <div
            class="reset-filter-button ml-1 custom-margin-top-6"
            @click="clickButtonClearFilter"
          >
            <span>Reset</span>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div class="row card-padding-top">
      <div class="col-12">
        <b-table
          sticky-header
          responsive
          :items="items"
          :fields="fields"
          :hover="true"
          @row-clicked="selectRow"
        >
          <template #cell(serviceStatus)="data">
            <b-badge pill :variant="badgeVariant(data.value)">{{
              data.value
            }}</b-badge>
          </template>
          <template #cell(serviceName)="data">
            <div class="header">{{ data.value }}</div>
          </template>
          <template #cell(totalPackage)="data">
            <div class="header">{{ data.value }}</div>
          </template>
        </b-table>
      </div>
      <div class="d-flex justify-content-between w-100 card-padding">
        <div class="col-6">Showing {{ items.length }} entries</div>
        <div class="col-6 d-flex justify-content-end">
          <b-pagination
            v-model="filterList.pageNumber"
            :total-rows="filterList.totalCount"
            :per-page="perPage"
            size="sm"
            class="my-0"
          ></b-pagination>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import { BBadge, BCard, BPagination, BTable } from "bootstrap-vue"
import AtomButton from "@/components/atoms/AtomButton.vue"
import AtomInput from "@/components/atoms/AtomInput.vue"
import AtomMultiSelect from "@/components/atoms/AtomMultiSelect.vue"
import mixinsUser from "@/mixins/mixinsUser"
import { PermissionUser } from "@/constants/permission-user"

export default {
  name: "OrganismServiceDataManagement",
  components: {
    AtomButton,
    AtomInput,
    AtomMultiSelect,
    BBadge,
    BCard,
    BPagination,
    BTable,
  },
  mixins: [mixinsUser],
  props: {
    filterList: {
      required: true,
      type: Object,
    },
    fields: {
      type: Array,
      required: false,
      default: () => [],
    },
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  emits: ["onUpdateFilterData", "onSetDefaultFilterData", "onChangePage"],
  data() {
    return {
      perPage: 10,
    }
  },
  computed: {
    hasUpdatePermission() {
      return this.hasPermission(PermissionUser.SETTINGS_WRITE)
    },
  },
  watch: {
    "filterList.currentPage": {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$emit("onUpdateCurrentPage", this.filterList)
        }
      },
    },
  },
  methods: {
    badgeVariant(status) {
      return status.toLowerCase() === "active"
        ? "light-success"
        : "light-secondary"
    },

    selectRow(service) {
      const path = `/global-settings/data-management/service/${service.serviceId}`
      this.navigateTo(path)
    },

    navigateTo(path) {
      this.$router.push(path)
    },

    clickButtonSearch() {
      this.$emit("onUpdateFilterData", this.filterList)
    },

    clickButtonClearFilter() {
      this.$emit("onSetDefaultFilterData")
    },

    toPascalCase(str) {
      return str.replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => {
        return chr.toUpperCase()
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.header__label {
  font-weight: 500;
  font-size: 18px;
  color: #5e5873;
}

.card-padding {
  padding: 1.5rem;
}

.reset-filter-button {
  color: #b9b9c3;
  margin-bottom: 8px;
  text-decoration: underline;
  &:hover {
    cursor: pointer;
    color: #7367f0;
  }
}
</style>
